import { getPrice, isDiscounted } from "../../../utils/discountPriceData";
import { GRID_PRICE } from "../priceTypes";
import PropTypes from "prop-types";
import CurrentPrice from "../currentPrice/CurrentPrice";
import PreviousPrice from "../previousPrice/PreviousPrice";
import styles from "./GridPrice.scss";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";
import PercentageDiscount from "../percentageDiscount/PercentageDiscount";
import useRemoveDiscountPercentage from "../../../hooks/useRemoveDiscountPercentage";

export default function GridPrice({ priceData, showAdvertElements }) {
  const { getTranslation } = useRuntimeConstants();
  const { shouldRemoveDiscountPercentage } = useRemoveDiscountPercentage();
  const isPriceDiscounted = isDiscounted(priceData);
  const { currentPriceText, previousPriceText, percentageDiscountLabel } =
    getPrice({ translations: getTranslation, priceData });

  const gridStyle = showAdvertElements
    ? styles.gridPriceSpaced
    : styles.gridPrice;

  return (
    <div className={gridStyle}>
      <span className={styles.priceAndDiscount}>
        <CurrentPrice
          currentPriceText={currentPriceText}
          showVatMessage={false}
          priceStyle={GRID_PRICE}
          isSalePrice={isPriceDiscounted}
        />
        {isPriceDiscounted && !shouldRemoveDiscountPercentage && (
          <PercentageDiscount
            percentageDiscountLabel={percentageDiscountLabel}
          />
        )}
      </span>
      {isPriceDiscounted && !shouldRemoveDiscountPercentage && (
        <PreviousPrice
          previousPriceText={previousPriceText}
          priceStyle={GRID_PRICE}
        />
      )}
    </div>
  );
}

GridPrice.propTypes = {
  priceData: PropTypes.shape({
    current: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number,
    }).isRequired,
    previous: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number,
    }),
    rrp: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number,
    }),
    isMarkedDown: PropTypes.bool,
    isOutletPrice: PropTypes.bool,
  }).isRequired,
  showAdvertElements: PropTypes.bool,
};
